import { SwitchField } from '@openx/components-core/lib/SwitchField/SwitchField.tsx';
import type { Option } from '@openx/types/options.ts';

type SwitchSelectorProps = {
  selectedOption: string | undefined;
  onOptionChange: (options: string) => void;
  option?: Option[];
};

export const SwitchSelector = ({ option, selectedOption, onOptionChange }: SwitchSelectorProps) => {
  return (
    <SwitchField
      value={selectedOption}
      checked={!!selectedOption}
      formControlLabelSx={{ marginRight: 0 }}
      onChange={e => {
        const isChecked = (e.target as HTMLInputElement).checked;
        const pickedOption = option?.[0]?.id ?? '';

        onOptionChange(isChecked ? pickedOption : '');
      }}
    />
  );
};
